import { ModelStatus, PrometheusEditorContainerRoot, ServerSessionInfo, SubspaceType} from '@tableau/predictive-model-ui';
import { Objective } from '@tableau/predictive-model-ui/lib/src/content/PredictiveModel';
import { PrepEmbeddingProps } from '@tableau/predictive-model-ui/lib/src/content/PrepEmbedding';
import { Algorithm, Goal, TrainingStatus } from '@tableau/predictive-model-ui/lib/src/util/Utils';
import { SiteUrls } from '@tableau/shared-urls';
import React from 'react';

import { BrowserTitleService } from '~src/commonInfra/services/BrowserTitleService';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { SpaceContainerStyles } from '~src/spacesPlatform/style/SpaceContainerStyles';

import { SessionSiteSelectors } from '../../bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '../../bootstrap/redux/store/AppStore';
export interface PredictiveModelEditorSpaceOwnProps {
  // TODO - Props for predictive model
  // WHATEVER you add here, it needs to be passed from PredictiveModelEditorSpaceProvider
}

export interface PredictiveModelEditorSpaceStateProps {
  //TODO - State props for predictivemodel
}

export interface PredictiveModelEditorSpaceDispatchProps {
    //TODO - Dispatch props for predictivemodel
  readonly requestSpaceContents: () => void;
}

export type PredictiveModelEditorSpaceProps = PredictiveModelEditorSpaceStateProps
  & PredictiveModelEditorSpaceDispatchProps
  & PredictiveModelEditorSpaceOwnProps;

//const testIdPrefix = 'predictive-model';
// const HEADER_TEST_ID = `${testIdPrefix}-header`;
// const EMPTY_STATE_TEST_ID = `${testIdPrefix}-empty-state`;

export class PredictiveModelEditorSpace extends React.PureComponent<PredictiveModelEditorSpaceProps> {

  private server: ServerSessionInfo;
  constructor(props: PredictiveModelEditorSpaceProps) {
    super(props);
    let sessionManagement = getSessionManagementServiceInstance();
    this.server = {
      serverSessionLanguage : sessionManagement.sessionLanguage(),
      sessionServerVersionBuild: sessionManagement.sessionServerVersion().build,
      sessionServerVersionPlatform: sessionManagement.sessionServerVersion().platform,
      sessionUserId: sessionManagement.sessionUserId(),
      sessionSiteId: sessionManagement.sessionSiteId(),
      sessionUserLuId: sessionManagement.sessionUserInfo().luid
    };
  }
  public componentDidMount() {
    BrowserTitleService.setTitleWithPlaceEntityName({ placeEntityName: 'predictive model' });
    this.props.requestSpaceContents();
  }
   defaultObjective: Objective = {
    dataSourceId: 'Select',
    dataSourceVersionId: 'Select',
    flowId: '',
    outcomeField: 'Select',
    goal: Goal.Maximize,
    algorithm: Algorithm.GLM,
    outcomeType: '',
    successValue: '',
    failureValue: '',
    predictionType: '',
    domain: [],
  };
  defaultTrainingStatus: TrainingStatus ={
    previousUpdates: [],
  };
  public render(): JSX.Element {
    const siteUrlName: string = SessionSiteSelectors.siteUrlName(getAppStore().getState());
    const siteUrl: SiteUrls = new SiteUrls({
      siteUrlName: siteUrlName,
      queryString: 'prometheusPredictiveModelEnabled=true/'});
    const prepEmbeddingProps: PrepEmbeddingProps =  {
      siteUrls : siteUrl
    };
    return (
      <div className={SpaceContainerStyles.SpaceContainer}>
        <PrometheusEditorContainerRoot modelStatus={ModelStatus.Undefined} subspace={SubspaceType.Connect} objective={this.defaultObjective} error = {''} trainingStatus={this.defaultTrainingStatus} server={this.server} prepEmbeddingProps={prepEmbeddingProps}/>
      </div>
    );
  }
}
